import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top on every route change.
 * Uses instant scroll when the previous scroll position is >= 400px so the
 * new page doesn't visibly race past the old one; smooth otherwise.
 * If the user follows a #hash link, we honor the browser's native jump.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let the browser handle in-page anchors
    const y = window.scrollY || 0;
    const prefersReduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, left: 0, behavior: (prefersReduced || y > 400) ? 'auto' : 'smooth' });
  }, [pathname, hash]);
  return null;
}
